module.exports = __webpack_public_path__ + "img/모니터링추가.7e8771b8.png";